import gsap from 'gsap'
import DrawSVGPlugin from 'gsap/DrawSVGPlugin'
import MotionPathPlugin from 'gsap/MotionPathPlugin'
import ScrollTrigger from 'gsap/ScrollTrigger'

// Register GSAP plugins safely
if (gsap) {
	gsap.registerPlugin(DrawSVGPlugin);
	gsap.registerPlugin(MotionPathPlugin);
	gsap.registerPlugin(ScrollTrigger);
}

let timeline_items = document.querySelectorAll(".vertical-timeline-item");

/**
 * Animation Timeline with images
 */
let containerTimeLineImages = document.querySelector('.vertical-timeline-images');
if (containerTimeLineImages) {
    ScrollTrigger.matchMedia({
        "(min-width: 767px)": function() {        
    
            timeline_items.forEach((e, index) => {

                var containerHeight = e.offsetHeight;
                let eLine = e.querySelector('.vertical-line')

                // Diagonal Line
                let dLine = e.querySelector('.vertical-line-child')
                gsap.to(dLine, {
                    scrollTrigger: {
                        trigger: dLine,
                        toggleActions: "restart none none pause",
                        scrub: true,
                        start: "top 70%",
                        end: "+="+(containerHeight-100)
                    },
                    height: containerHeight - 60,
                    duration: 1
                })


                // Straigh Line
                gsap.to(eLine, {
                    scrollTrigger: {
                        trigger: eLine,
                        toggleActions: "restart none none pause",
                        scrub: true,
                        start: "top 70%",
                        end: "+="+(containerHeight-100)
                    },
                    height: containerHeight,
                    duration: 1
                })

                let eDot = e.querySelector('.timeline-dot')
                let eCard = e.querySelector('.timeline-card')
                ScrollTrigger.create({
                    trigger: eDot,
                    toggleActions: "restart none none pause",
                    start: "-100px 70%",
                    end: "-100px 70%",
                    onEnter: () => { 
                        eDot.className += " show"
                        eCard.classList.add("fade-in");
                     },
                    onLeaveBack: () => { 
                        eDot.classList.remove("show");
                        eCard.classList.remove("fade-in");
                     },
                    id: "dot",
                })
            })
        }
    })
}    


/**
 * Animation Timeline with steps
*/
 let containerTimeLineSteps = document.querySelector('.vertical-timeline-steps');
 if (containerTimeLineSteps) {
     ScrollTrigger.matchMedia({
         "(min-width: 767px)": function() {        
             timeline_items.forEach((e, index) => {
                 let eStep = e.querySelector('.timeline-counter')
                 let eCard = e.querySelector('.timeline-card')
                 ScrollTrigger.create({
                     trigger: eStep,
                     toggleActions: "restart none none pause",
                     start: "-100px 70%",
                     end: "-100px 70%",
                     onEnter: () => { 
                        eStep.className += " show"
                        eCard.classList.add("fade-in");
                      },
                     onLeaveBack: () => { 
                        eStep.classList.remove("show");
                        eCard.classList.remove("fade-in");
                      }
                 })
             })
         }
     })
 }  